import { render } from "./allpayments.vue?vue&type=template&id=24e7eaa6"
import script from "./allpayments.vue?vue&type=script&lang=js"
export * from "./allpayments.vue?vue&type=script&lang=js"

import "./allpayments.vue?vue&type=style&index=0&id=24e7eaa6&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__